import React from 'react';
import { aboutText } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Historical image */}
            <div className="relative">
              <div className="rounded-xl overflow-hidden shadow-lg">
                <img 
                  src="https://lirp.cdn-website.com/1d57ed00/dms3rep/multi/opt/dandie_store_streetsville_c1900-1920w.webp" 
                  alt="Historical Streetsville circa 1900" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
              <div className="absolute -bottom-4 left-4 bg-white px-6 py-3 rounded-lg shadow-md">
                <p className="text-sm text-gray-600">Serving Since 1974</p>
              </div>
            </div>

            {/* About text */}
            <div className="space-y-6">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                {aboutText.heading}
              </h2>
              <p className="text-gray-600 leading-relaxed">
                {aboutText.description}
              </p>
              <div className="flex items-center gap-6 pt-4">
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600">52+</div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
                <div className="w-px h-12 bg-gray-300"></div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600">1000+</div>
                  <div className="text-sm text-gray-600">Happy Clients</div>
                </div>
                <div className="w-px h-12 bg-gray-300"></div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-red-600">100+</div>
                  <div className="text-sm text-gray-600">Designer Brands</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
